import React, { useEffect } from 'react';
import './BarterKingDrawer.css'; // reuse same styles

export default function CreatorFlameDrawer({ open, onClose }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === 'Escape' && onClose?.();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="bkdr-overlay" role="dialog" aria-modal="true" aria-label="About Creator Flame">
      <div className="bkdr-scrim" onClick={onClose} />
      <div className="bkdr-sheet" tabIndex={-1}>
        <div className="bkdr-handle" />
        <div className="bkdr-header">
          <div className="bkdr-emoji" aria-hidden>🔥</div>
          <div className="bkdr-title">Creator Flame</div>
          <button className="bkdr-close" onClick={onClose} aria-label="Close">✕</button>
        </div>

        <div className="bkdr-content">
          <p className="bkdr-lead">
            Creator Flame celebrates creators whose posts are getting strong engagement in the current reward period.
          </p>

          <ul className="bkdr-list">
            <li><b>What counts?</b> Likes, comments, and tips on your content.</li>
            <li><b>Who gets it?</b> The top creators on the leaderboard.</li>
            <li><b>What helps?</b> Posting good content that people react to.</li>
            <li><b>How to climb?</b> Focus on quality posts and real engagement.</li>
          </ul>

          <div className="bkdr-hint">
            Good posts that people enjoy will help you stand out.
          </div>
        </div>
      </div>
    </div>
  );
}
